document.addEventListener('DOMContentLoaded', function () {
  var bstCache = {};
  var CACHE_TTL_MS = 5 * 60 * 1000;
  var FETCH_TIMEOUT_MS = 20000;

  var sections = document.querySelectorAll('.best-sellers-tabs');

  sections.forEach(function (section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.bst-tabs__tab'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.bst-tabs__panel'));

    var panelMap = {};
    panels.forEach(function (p) {
      panelMap[p.getAttribute('data-panel-index')] = p;
    });

    section.addEventListener('click', function (e) {
      var tab = e.target.closest('.bst-tabs__tab');
      if (!tab) return;

      var idx = tab.getAttribute('data-tab-index');
      var panel = panelMap[idx];
      if (!panel) return;

      tabs.forEach(function (t) {
        t.classList.toggle('active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });

      panels.forEach(function (p) {
        p.classList.toggle('active', p === panel);
      });

      ensurePanelLoaded(tab, panel);
    });

    function ensurePanelLoaded(tab, panel) {
      if (!tab || !panel) return;
      fetchAndRender(tab, panel);
    }

    var initialTab = section.querySelector('.bst-tabs__tab.active') || tabs[0];
    if (initialTab) {
      var idx = initialTab.getAttribute('data-tab-index');
      ensurePanelLoaded(initialTab, panelMap[idx]);
    }
  });

  function parseProductHref(href) {
    if (!href) return { url: '', handle: '' };
    try {
      var a = document.createElement('a');
      a.href = href;
      var path = a.pathname || '';
      var i = path.indexOf('/products/');
      if (i === -1) return { url: href, handle: '' };

      var handle = decodeURIComponent(path.slice(i + 10).split('/')[0] || '').toLowerCase();
      return {
        handle: handle,
        url: a.origin + '/products/' + handle
      };
    } catch (e) {
      return { url: href, handle: '' };
    }
  }

  function dedupeKey(card) {
    return (
      (card.getAttribute('data-bst-handle') || '').toLowerCase() ||
      parseProductHref(card.querySelector('a[href*="/products/"]')?.href).handle ||
      '_fallback_' + Math.random()
    );
  }

  function parseHtmlToCards(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    return Array.prototype.slice.call(temp.querySelectorAll('.bst-card-item'));
  }

  function buildFragment(cards, limit) {
    var frag = document.createDocumentFragment();
    var seen = {};
    var count = 0;

    for (var i = 0; i < cards.length && count < limit; i++) {
      var key = dedupeKey(cards[i]);
      if (!seen[key]) {
        seen[key] = true;
        frag.appendChild(cards[i]);
        count++;
      }
    }

    return frag;
  }

  function interleaveCardArrays(arrays, limit) {
    var frag = document.createDocumentFragment();
    var seen = {};
    var count = 0;
    var maxLen = Math.max.apply(null, arrays.map(a => a.length));

    for (var i = 0; i < maxLen && count < limit; i++) {
      for (var j = 0; j < arrays.length && count < limit; j++) {
        var card = arrays[j][i];
        if (!card) continue;

        var key = dedupeKey(card);
        if (!seen[key]) {
          seen[key] = true;
          frag.appendChild(card);
          count++;
        }
      }
    }

    return frag;
  }

  function wrapGrid(fragment) {
    var wrapper = document.createElement('div');
    wrapper.className = 'bst-tabs__scroll-wrapper';

    var grid = document.createElement('div');
    grid.className = 'bst-tabs__grid';

    grid.appendChild(fragment);
    wrapper.appendChild(grid);

    return wrapper;
  }

  function extractProductsPayload(cards) {
    return cards.map(function (card) {
      return {
        handle: card.getAttribute('data-bst-handle'),
        url: card.getAttribute('data-bst-url'),
        html: card.outerHTML
      };
    });
  }

  function applyCached(panel, cached) {
    var temp = document.createElement('div');
    temp.innerHTML = cached.products.map(p => p.html).join('');

    var cards = Array.prototype.slice.call(temp.children);
    var frag = buildFragment(cards, cards.length);

    panel.innerHTML = '';
    panel.appendChild(wrapGrid(frag));

    initDataLinks(panel);
  }

  function fetchAndRender(tab, panel) {
    if (panel.getAttribute('data-bst-loaded') === 'true') return;

    var handles = (tab.getAttribute('data-collections') || '')
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);

    if (!handles.length) return;

    var cacheKey = handles.slice().sort().join('|');

    var cached = bstCache[cacheKey];
    if (cached && Date.now() - cached.timestamp < CACHE_TTL_MS) {
      applyCached(panel, cached);
      panel.setAttribute('data-bst-loaded', 'true');
      return;
    }

    var version = Number(panel.getAttribute('data-bst-version') || 0) + 1;
    panel.setAttribute('data-bst-version', version);
    panel.setAttribute('data-bst-loaded', 'loading');

    if (panel._bstRequest) {
      panel._bstRequest.controller.abort();
      clearTimeout(panel._bstRequest.timeoutId);
    }

    var controller = new AbortController();
    var timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

    panel._bstRequest = { controller, timeoutId, version };

    var requests = handles.map(function (handle) {
      var url = `/collections/${handle}?sort_by=best-selling&sections=best-sellers-cards`;

      return fetch(url, { signal: controller.signal })
        .then(res => (res.ok ? res.json() : {}))
        .then(json => json['best-sellers-cards'] || '');
    });

    Promise.allSettled(requests)
      .then(function (results) {
        if (Number(panel.getAttribute('data-bst-version')) !== version) return;

        var htmlResults = results.map(r => (r.status === 'fulfilled' ? r.value : ''));

        var cardArrays = htmlResults.map(parseHtmlToCards);

        var fragment =
          cardArrays.length === 1
            ? buildFragment(cardArrays[0], 5)
            : interleaveCardArrays(cardArrays, 5);

        panel.innerHTML = '';

        if (!fragment.childNodes.length) {
          panel.innerHTML = '<div class="bst-tabs__loading">No products found.</div>';
          bstCache[cacheKey] = { timestamp: Date.now(), products: [] };
        } else {
          panel.appendChild(wrapGrid(fragment.cloneNode(true)));
          initDataLinks(panel);

          bstCache[cacheKey] = {
            timestamp: Date.now(),
            products: extractProductsPayload(Array.from(fragment.childNodes))
          };
        }

        panel.setAttribute('data-bst-loaded', 'true');
      })
      .catch(function () {
        if (Number(panel.getAttribute('data-bst-version')) !== version) return;
        panel.innerHTML = '<div class="bst-tabs__loading">Failed to load products.</div>';
        panel.setAttribute('data-bst-loaded', 'error');
      })
      .finally(function () {
        clearTimeout(timeoutId);
        if (panel._bstRequest?.version === version) {
          delete panel._bstRequest;
        }
      });
  }

  function initDataLinks(container) {
    container.querySelectorAll('[data-link-parent]').forEach(function (parent) {
      if (parent.dataset.bstLinkInit === 'true') return;

      var link = parent.querySelector('[data-link-child]');
      if (!link) return;

      parent.dataset.bstLinkInit = 'true';
      parent.classList.add('is-clickable');

      parent.addEventListener('click', function (e) {
        if (!e.target.closest('.quick-add__submit')) {
          window.location.href = link.href;
        }
      });
    });
  }
});